export default `float s=2., l=0.;
    p=abs(p);
    for(int j=0;j++<8;)
      p=1.-abs(abs(p-2.)-1.),
      p*=l=1.2/dot(p,p), s*=l;
    return dot(p,normalize(vec3(3.0,-2.0,-1.0)))/s;
  }`